import RestClient from '../../../../api/axiosInterceptor';
import {
  doctorLoginActions,
  doctorLogoutActions,
} from '../../../actions/user/doctor/login';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch the request action before making the API call
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    // Check if response exists and has data
    if (!response || !response.data) {
      throw new Error('Invalid response from server');
    }

    // Dispatch the success action with the response data
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data,
    });

    return response; // Return the response data

  } catch (error) {
    // Extract error message from various possible locations
    const errorMessage = 
      error.response?.data?.error || 
      error.response?.data?.message || 
      error.message || 
      'An error occurred';

    // Dispatch failure action
    dispatch({
      type: actionType.FAILURE,
      error: errorMessage,
    });

    // Show error toast
    toast.error(errorMessage, { position: "top-center" });
    throw error; // Re-throw the error for handling in the component
  }
};

// Action creator for doctor login
export const loginDoctor = (formData, verification_id) => {
  const data = {
    ...formData,
    verification_id,
  };
  
  return createAsyncAction(doctorLoginActions.LOGIN_DOCTOR, () =>
    RestClient.post('/auth1/', data, {
      headers: { 'Content-Type': 'application/json' },
    })
  );
};

// Action creator for doctor logout
export const logoutDoctor = () => 
  createAsyncAction(doctorLogoutActions.LOGOUT_DOCTOR, () =>
    RestClient.post('/auth1/logout')
  );